export const loadState = () => {
  try {
    const serializedState: any = localStorage.getItem('persist:state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state: any) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('persist:state', serializedState);
    return undefined;
  } catch (err) {
    return undefined;
  }
};
